import { useCallback } from 'react'
import type { DateText, HourMinute } from '~/lib/graphql/scalars'
import { useTransition } from './stateMachine/state'

type Payload = {
  visitorsCount: number
  visitDate: DateText
  visitTime: HourMinute
}

export function useChangeReserveCondition() {
  const send = useTransition()
  return useCallback(
    (payload: Payload) => {
      return send({
        type: 'reserveConditionChanged',
        ...payload,
      })
    },
    [send]
  )
}
